<template>
  <div class="search-bar"
    v-if="searchList.length>0">
    <div class="flex-row top-bar">
      <span :class="iconClass">&nbsp;&nbsp; {{ $t(titleName)}}</span>
    </div>
    <van-grid :gutter="10"
      column-num="3">
      <van-grid-item v-for="item in searchList"
        :key="item.id"
        :clickable="true"
        @click="selectItem(item)"
        :text="item.name"
        :class="{'active':item.checked}" />
    </van-grid>
  </div>
</template>

<script>
import webService from "@/network/webService";
import _ from "lodash";
import commonjs from "@/common/common";
import storejs from "@common/store.js";
export default {
  name: "SearchTypeBar",
  props: ["searchType", "title"],
  components: {},
  data () {
    return {
      searchList: [],
      titleName: "",
      iconClass: "",
    };
  },
  created () {
    if (this.title) {
      this.titleName = this.title;
    } else {
      this.titleName = "common." + this.searchType;
    }
    this.iconClass = "iconfont icongrow-revenue-outline";
    if (this.searchType == commonjs.commonInfoEnmus.OrgStage) {
      this.iconClass = "iconfont icongrow-revenue-outline";
    } else if (this.searchType == commonjs.commonInfoEnmus.OrgIndustry) {
      this.iconClass = "iconfont icongrowth-outline";
    } else if (
      this.searchType == commonjs.commonInfoEnmus.CompanyIndustry
    ) {
      this.iconClass = "iconfont iconcapital-outline";
    } else if (this.searchType == commonjs.commonInfoEnmus.CompanyRound) {
      this.iconClass = "iconfont icongrowth-outline";
    } else if (
      this.searchType == commonjs.commonInfoEnmus.CompanyInvestmentDate
    ) {
      this.iconClass = "iconfont iconcenter-map-outline";
    } else if (this.searchType == commonjs.commonInfoEnmus.Title) {
      this.iconClass = "iconfont iconaudience-fill";
    } else if (this.searchType == commonjs.commonInfoEnmus.RelationDeepth) {
      this.iconClass = "iconfont icongrow-revenue-fill";
    } else if (this.searchType == commonjs.commonInfoEnmus.NewsType) {
      this.iconClass = "iconfont icongrid-view-outline";
    } else if (this.searchType == commonjs.commonInfoEnmus.MarketPeriod) {
      this.iconClass = "iconfont icontime-outline";
    } else if (this.searchType == commonjs.commonInfoEnmus.exitIPO) {
      this.iconClass = "iconfont icontime-outline";
    } else if (this.searchType == commonjs.commonInfoEnmus.exitSales) {
      this.iconClass = "iconfont icontime-outline";
    } else if (this.searchType == commonjs.commonInfoEnmus.dates) {
      this.iconClass = "iconfont icontime-fill";
    } else if (this.searchType == commonjs.commonInfoEnmus.userIndustry) {
      this.iconClass = "iconfont iconcapital-outline";
    }
    this.loadData(this.searchType);
  },
  methods: {
    loadData (typeString) {
      if (typeString) {
        var params = [this.searchType];

        webService.getCommonData(params).then((res) => {
          res.data.forEach((m) => {
            m.checked = false;
          });

          if (
            this.searchType == commonjs.commonInfoEnmus.OrgStage ||
            // this.searchType == commonjs.commonInfoEnmus.NewsType ||
            this.searchType ==
            commonjs.commonInfoEnmus.MarketPeriod ||
            this.searchType ==
            commonjs.commonInfoEnmus.stockExchange ||
            this.searchType ==
            commonjs.commonInfoEnmus.RelationDeepth ||
            this.searchType ==
            commonjs.commonInfoEnmus.CompanyInvestmentDate ||
            this.searchType ==
            commonjs.commonInfoEnmus.dates
          ) {
            this.searchList = _.orderBy(
              res.data,
              ["sort"],
              ["asc"]
            );
            this.initSelectItem();
          } else {
            var object = {
              sort: 0,
              name: "全部",
              checked: false,
            };
            res.data.push(object);
            this.searchList = _.orderBy(
              res.data,
              ["sort"],
              ["asc"]
            );
            this.initSelectItem();
          }
        });
      }
    },
    selectItem (item) {
      if (
        this.searchType == commonjs.commonInfoEnmus.OrgStage ||
        // this.searchType == commonjs.commonInfoEnmus.NewsType ||
        this.searchType == commonjs.commonInfoEnmus.MarketPeriod ||
        this.searchType == commonjs.commonInfoEnmus.stockExchange ||
        this.searchType ==
        commonjs.commonInfoEnmus.CompanyInvestmentDate ||
        this.searchType == commonjs.commonInfoEnmus.RelationDeepth ||
        this.searchType == commonjs.commonInfoEnmus.dates
      ) {
        this.searchList.forEach((m) => {
          m.checked = false;
        });
        item.checked = !item.checked;
      } else {
        if (item.name == "全部") {
          if (!item.checked) {
            this.searchList.forEach((m) => {
              m.checked = false;
            });
            item.checked = !item.checked;
          } else {
            this.searchList.forEach((m) => {
              m.checked = false;
            });
            // this.searchList.forEach((m) => {
            //   m.checked = false;
            // });
            // item.checked = !item.checked;
          }
        } else {
          var checkAll = _.find(this.searchList, function (key) {
            return key.name == "全部";
          });
          if (checkAll && checkAll.checked) {
            checkAll.checked = !checkAll.checked;
          }
          item.checked = !item.checked;
        }
      }
    },
    reset () {
      this.searchList.forEach((m) => {
        m.checked = false;
      });
    },
    search (searchValue) {
      let searchList = [searchValue];
      this.$emit("typeClick", this.searchType, searchList);
    },
    initSelectItem (isOrg) {
      if (this.searchType == commonjs.commonInfoEnmus.OrgStage) {
        this.validateSelect(storejs.state.orgStage);
      } else if (this.searchType == commonjs.commonInfoEnmus.OrgIndustry) {
        console.log(storejs.state);
        if (isOrg) {
          this.validateSelect(storejs.state.orgIndustry);
        }
        else {
          this.validateSelect(storejs.state.companyIndustry);
        }
      }
      else if (this.searchType == commonjs.commonInfoEnmus.CompanyRound) {
        this.validateSelect(storejs.state.companyRound);
      } else if (this.searchType == commonjs.commonInfoEnmus.CompanyInvestmentDate) {
        this.validateSelect(storejs.state.companyInvestmentDate);
      }
    },
    validateSelect (item) {
      if (item) {
        this.searchList.forEach((m) => {
          if (m.id == item.id) {
            m.checked = true;
          } else {
            m.checked = false;
          }
        });
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.search-bar {
  //height: 100%;
  padding-bottom: 1rem;
}
/deep/ .iconfont {
  font-size: 12px;
}
.top-bar {
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1rem;
  color: #504e4e;
}
.title {
  font-size: 14px;
  font-weight: 600;
}
/deep/ .van-grid-item__content {
  padding: 4px 4px;
  background-color: #f2f2f2;
  border: 1px solid #dedede;
}
/deep/ .van-grid-item__text {
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #7d7d7d;
}
.active {
  /deep/ .van-grid-item__text {
    color: #c52a1a;
  }
  /deep/ .van-grid-item__content {
    background-color: #f7c8c4 40%;
    border: 1px solid #c52a1a;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/SearchTypeBar.vue